module.exports = __webpack_public_path__ + "public/StoreIcon/transactionManagement.svg?5d588b04";